import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-98a79d14"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "crypto-choice-card"
};
const _hoisted_2 = {
    key: 0,
    class: "container"
};
const _hoisted_3 = { class: "grid-cell-5" };
const _hoisted_4 = { class: "grid-cell-1" };
const _hoisted_5 = { class: "grid-cell-2" };
const _hoisted_6 = { class: "grid-cell-3" };
const _hoisted_7 = { class: "grid-cell-4" };
const _hoisted_8 = {
    key: 1,
    class: "crypto-choice-card"
};
const _hoisted_9 = { class: "loader" };
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
import { useDashboard } from '@/logics/dashboard';
import { useMessage } from '@/const/messages';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean }
    },
    setup(__props) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const { getDashboardList } = useDashboard();
            const { DASHBOARD_PAGE, format } = useMessage();
            const cryptos = ref([]);
            if (props.isAuth) {
                cryptos.value = (([__temp, __restore] = _withAsyncContext(() => getDashboardList().catch((err) => {
                    console.error('Error: ', err);
                    return [];
                }))),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            return (_ctx, _cache) => {
                return (cryptos.value.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cryptos.value, (crypto) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: crypto.icon
                            }, [
                                (crypto.staking !== 0 || crypto.balance !== 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createVNode(CryptoIcon, {
                                                class: "crypto_icon",
                                                base: crypto.icon,
                                                width: 50
                                            }, null, 8, ["base"])
                                        ]),
                                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(format)(_unref(DASHBOARD_PAGE).BALANCE)), 1),
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(crypto.balance !== 0 ? crypto.balance + crypto.symbol : '--'), 1),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)(_unref(DASHBOARD_PAGE).STAKING)), 1),
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(crypto.staking !== 0 ? crypto.staking + crypto.symbol : '--'), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(format)(_unref(DASHBOARD_PAGE).EMPTY)), 1)
                    ]));
            };
        });
    }
});
